import { render, staticRenderFns } from "./hospitalproductusage.vue?vue&type=template&id=1f7a24c4"
import script from "./hospitalproductusage.vue?vue&type=script&lang=js"
export * from "./hospitalproductusage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports